import { render } from "./Abertura_Embalagem.vue?vue&type=template&id=20ea6a64&scoped=true"
import script from "./Abertura_Embalagem.vue?vue&type=script&lang=js"
export * from "./Abertura_Embalagem.vue?vue&type=script&lang=js"

import "./Abertura_Embalagem.vue?vue&type=style&index=0&id=20ea6a64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ea6a64"]])

export default __exports__